import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    tagsViewList: Cookies.get('tagsView')?JSON.parse(Cookies.get('tagsView')):[],
    device: 'desktop',
    currIndex: 0,
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    /**
     * 添加 tags
     */
		addTagsViewList(state, tag) {
			const isFind = state.tagsViewList.find(item => {
				return item.path === tag.path;
			});
			// 处理重复
			if (!isFind) {
				state.tagsViewList.push(tag);
				Cookies.set('tagsView', state.tagsViewList);
			}
		},
		/**
     * 删除 tag
     * @param {type: 'other'||'right'||'index', index: index} payload
     */
		removeTagsView(state, payload) {
			if (payload.type === "index") {
				state.tagsViewList.splice(payload.index, 1);
			} else if (payload.type === "other") {
				state.tagsViewList.splice(
					payload.index + 1,
					state.tagsViewList.length - payload.index + 1
				);
				state.tagsViewList.splice(0, payload.index);
				// if (payload.index != 0) {
				// 	// list第一位加入删除了的首页tag
				// 	state.tagsViewList.unshift({
				// 		fullPath: "/home",
				// 		meta: { title: "首页", affix: true },
				// 		name: "home",
				// 		params: {},
				// 		path: "/home",
				// 		query: {},
				// 		title: "首页"
				// 	});
				// }
			} else if (payload.type === "right") {
				state.tagsViewList.splice(
					payload.index + 1,
					state.tagsViewList.length - payload.index + 1
				);
			} else if (payload.type === "all") {
				state.tagsViewList = [];
			}
			Cookies.set('tagsView', state.tagsViewList);
		},
    setCurrIndex(state, currIndex) {
      state.currIndex = currIndex
    },
    clearTagsViewList(state) {
      state.tagsViewList = []
      Cookies.set('tagsView', state.tagsViewList)
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js